import { useNavigate } from "react-router-dom";
import { useNotifications } from "../../../contexts/NotificationsContext";
import Icon from "../../a-atoms/icons/Icon";
import Button from "../../b-molecules/buttons/Button";
import style from "./NotificationList.module.css";

const NotificationList = ({ onClose }) => {
  const { notifications, unreadCount, markAsRead, markAllAsRead } = useNotifications();
  const navigate = useNavigate();

  const handleNotificationClick = async (notification) => {
    // Mark as read
    await markAsRead(notification.id);
    
    // Navigate to journey with comments open
    const url = `/journeys/${notification.journeyId}?commentRowId=${notification.rowId}&commentCellId=${notification.cellId}`;
    navigate(url);
    onClose();
  };

  const handleMarkAllAsRead = async () => {
    await markAllAsRead();
  };

  const unreadNotifications = notifications.filter(n => !n.read);
  const readNotifications = notifications.filter(n => n.read);

  function formatTimestamp(timestamp) {
    if (!timestamp) return "";
    const date = new Date(timestamp);
    const now = new Date();
    const diffMs = now - date;
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMs / 3600000);
    const diffDays = Math.floor(diffMs / 86400000);

    if (diffMins < 1) return "Just now";
    if (diffMins < 60) return `${diffMins}m ago`;
    if (diffHours < 24) return `${diffHours}h ago`;
    if (diffDays < 7) return `${diffDays}d ago`;
    
    return date.toLocaleDateString();
  }

  return (
    <div className={style.notificationList}>
      <div className={style.header}>
        <span>Notifications</span>
        {unreadCount > 0 && (
          <Button
            variants={["text"]}
            onClick={handleMarkAllAsRead}
            className={style.markAllRead}
          >
            Mark all as read
          </Button>
        )}
        <Icon onClick={onClose}>close</Icon>
      </div>
      <div className={style.notificationsContent}>
        {notifications.length === 0 ? (
          <div className={style.emptyNotifications}>
            <p>No notifications</p>
          </div>
        ) : (
          <>
            {unreadNotifications.length > 0 && (
              <div className={style.section}>
                <div className={style.sectionHeader}>Unread</div>
                {unreadNotifications.map((notification) => (
                  <div
                    key={notification.id}
                    className={`${style.notificationItem} ${style.unread}`}
                    onClick={() => handleNotificationClick(notification)}
                  >
                    <div className={style.notificationIcon}>
                      <Icon>{notification.type === "mention" ? "alternate_email" : "reply"}</Icon>
                    </div>
                    <div className={style.notificationContent}>
                      <div className={style.notificationText}>
                        <strong>{notification.fromUserName}</strong>{" "}
                        {notification.type === "mention" ? "mentioned you" : "replied"} in{" "}
                        <strong>{notification.journeyName}</strong>
                      </div>
                      <div className={style.notificationPreview}>{notification.text}</div>
                      <div className={style.notificationTime}>
                        {formatTimestamp(notification.timestamp)}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
            {readNotifications.length > 0 && (
              <div className={style.section}>
                <div className={style.sectionHeader}>Read</div>
                {readNotifications.map((notification) => (
                  <div
                    key={notification.id}
                    className={style.notificationItem}
                    onClick={() => handleNotificationClick(notification)}
                  >
                    <div className={style.notificationIcon}>
                      <Icon>{notification.type === "mention" ? "alternate_email" : "reply"}</Icon>
                    </div>
                    <div className={style.notificationContent}>
                      <div className={style.notificationText}>
                        <strong>{notification.fromUserName}</strong>{" "}
                        {notification.type === "mention" ? "mentioned you" : "replied"} in{" "}
                        <strong>{notification.journeyName}</strong>
                      </div>
                      <div className={style.notificationPreview}>{notification.text}</div>
                      <div className={style.notificationTime}>
                        {formatTimestamp(notification.timestamp)}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default NotificationList;

